// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import { icon } from "~/util/dom";

window.LineChart = class {
	/**
	 * Vytvoreni profilu - vysky, rychlosti.
	 *
	 * Signaly:
	 * line-chart-move { frac, x, height, point }
	 * line-chart-enter { frac }
	 * line-chart-leave
	 *
	 * @param  {Object} altitudeData Hezka data  z backendu
	 * @param  {Number} distance Celkova vzdalenost v [m]
	 * @param  {Object} options Dalsi moznosti
	 */
	constructor(altitudeData, distance, options) {

		this._opts = {
			width: 400, // sirka a vyska canvasu
			height: 200,
			topPadding: 60, // kolik px uvolnit nahore pro min, max; vyska popisku je 30x2; do tohoto prostoru se musi vejit 2 popisky na vysku
			bottomHeight: 70, // min. v px z vysky, ktera je vyplnena zespodu
			maxPeakPadding: 10, // kolik px nechat na caru PEAK maxima
			elevationThreshold: 20, // threshold v metrech pro vysky
			leftRightEdge: 10, // pocet procent pro presun horniho popapu u okraju vlevo a vpravo
			activityData: null, // novinka pro aktivity
			// meritka
			xUnits: {
				"1":"m",
				"1000": "km"
			},
			yUnits: {
				"1": "m " + _("lineChart.elevation")
			},
			diffsUnits: {
				"1": "m"
			},
			measureSections: 3, // pocet dilku na meritku; 0 vypina renderovani meritka
			animation: true, // animace
			animationIncreaseStep: 0.06,
			animationIncreaseExponent: 1.01,
			// barvy
			colors: {
				circleFill: "#ffffff",
				minMaxLine: "#cccccc",
				topLine: "#828282", // puvodne #b0b0b0
				measure: "#ebebeb",
				filling: "#f4f4f4",
				gradientFill: ["#fafafa", "#e6e6e6"]
			},
			circleRadius: 3,
			domLoadCount: 2, // pocet pokusu pro nacteni
			domLoadTimeout: 100,
			domEdgeCorrection: 2.5, // pocet px, ktere se prictou/odectou u okraje
			domRepositionPadding: 10, // min vzdalenost mezi popisky
			noTitle: false
		};
		this._dom = {
			cover: document.createElement("div"),
			captions: []
		};
		this._dom.cover.classList.add("line-chart");
		this._items = [];
		this._sectionItems = [];
		this._drawItems = [];
		this._signals = [];
		this._domLoaded = false;
		this._domCount = this._opts.domLoadCount;
		this._distance = 0;
		this._altitudeData = null;
		this._processedData = {
			minAltitude: 0,
			maxAltitude: 0,
			elevationGain: 0,
			elevationLoss: 0
		};
		this._minAltitude = null;
		this._maxAltitude = null;
		this._domTimeout = null;

		this._opts = Object.assign(this._opts, options);

		// vytvoreni
		this._create();

		this.setData(altitudeData, distance, options);
	}

	/**
	 * Prenastaveni dat vyskovemu profilu - je mozne i s animaci.
	 *
	 * @param  {Array} altitudes Pole vysek
	 * @param  {Number} distance Celkova vzdalenost v [m]
	 * @param  {Object} options Dalsi moznosti
	 */
	setData(altitudeData = this._altitudeData, distance = this._distance, options) {
		this._opts = Object.assign(this._opts, options);
		this._drawLine = null;
		this._mouseMoveData = {
			id: 0,
			timeout: 1000 / 240 // 1000 / FPS
		};
		this._topPaddingPy = {
			min: Math.round(this._opts.topPadding),
			max: Math.round(0.5 * this._opts.topPadding)
		};
		this._t = !("ServerSide" in window) && this._opts.animation ? 0 : 1;
		this._increase = this._opts.animationIncreaseStep;
		this._altitudeData = altitudeData;
		this._distance = distance;
		this._prevBaseY = this._drawItems ? this._drawItems.map(i => i.y) : null;

		if (this._distance <= 0) {
			this._set();
			return;
		}

		this._processData();
		this._sectionItems = this._getSectionItems();

		// nastavime hodnoty do DOMu
		this._set();

		// kresleni na canvas
		this._animation();

		// nastaveni po pripnuti do DOMu
		this._waitForDOM();
	}

	/**
	 * Odstraneni.
	 */
	destroy() {
		if (this._domTimeout) {
			clearTimeout(this._domTimeout);
			this._domTimeout = null;
		}

		if (this._dom.canvasCover) {
			this._dom.canvasCover.removeEventListener("mousemove", this);
			this._dom.canvasCover.removeEventListener("mouseenter", this);
			this._dom.canvasCover.removeEventListener("mouseleave", this);
			this._dom.canvasCover.removeEventListener("click", this);
		}

		this._dom.cover.remove();
		this._dom.cover = null;
		this._dom.canvasCover = null;

		this._signals = [];
	}

	/**
	 * Ziskani obalu vyskoveho profilu.
	 *
	 * @return {Element}
	 */
	getContainer() {
		return this._dom.cover;
	}

	/**
	 * Staticka metoda, jestli je canvas podporovany.
	 *
	 * @return {Boolean}
	 */
	static isSupported() {
		return document.createElement("canvas").getContext;
	}

	/**
	 * Pridani posluchace na signal.
	 *
	 * @param  {String}   name  Nazev signalu
	 * @param  {Function} cb
	 * @param  {Object}   [scope] Volitelny scope
	 */
	addListener(name, cb, scope) {
		if (typeof name === "string" && typeof cb === "function") {
			this._signals.push({
				name,
				cb,
				scope
			});
		}
	}

	/**
	 * Odstraneni posluchace na signal.
	 *
	 * @param  {String}   name  Nazev signalu
	 * @param  {Function} cb
	 * @param  {Object}   [scope] Volitelny scope
	 */
	removeListener(name, cb, scope) {
		for (let i = 0; i < this._signals.length; i++) {
			let item = this._signals[i];

			if (item.name == name && item.cb == cb && (!scope || scope == item.scope)) {
				this._signals.splice(i, 1);
				break;
			}
		}
	}

	/**
	 * Zobraz vysku v % trasy.
	 * showPointer
	 *
	 * @param  {Number} perc <0; 100>
	 */
	showAtPerc(perc) {
		let percNorm = perc / 100;
		let item = this._getItemOnPerc(percNorm);

		if (item) {
			this._drawLine = Object.assign({}, item, {
				x: (this._opts.width - 1) * percNorm,
				perc: percNorm
			});

			this._animation();
			this._dom.canvasCover.classList.add("show-popup");
			this._setTopPopup(perc);
			this._setBottomPopup();
		}
	}

	/**
	 * Smazani pomocneho popupu pro zobrazeni vysky v bodu.
	 * hidePointer
	 */
	clear() {
		this._drawLine = null;
		this._animation();
		this._dom.canvasCover.classList.remove("show-popup");
	}

	/**
	 * Prekresleni canvasu.
	 *
	 * @param  {Array} items Vlastni polozky - pro kazdy pixel 1 item
	 * @param  {Array} measure Pro kazdy dilek 1 item
	 */
	redraw(items = this._drawItems, measure = this._sectionItems) {
		if (!this._dom.canvas || !items.length) return;

		let ctx = this._dom.canvas.getContext("2d");
		ctx.clearRect(0, 0, this._opts.width, this._opts.height);
		ctx.lineWidth = 1;

		// vypln
		let gradient = ctx.createLinearGradient(0, this._opts.height - 1, 0, 0);
		gradient.addColorStop(0, this._opts.colors.gradientFill[0]);
		gradient.addColorStop(1, this._opts.colors.gradientFill[1]);

		ctx.strokeStyle = gradient;
		ctx.fillStyle = gradient;

		ctx.beginPath();
		ctx.lineCap = "square";
		ctx.moveTo(0, this._opts.height - 1);
		items.forEach(item => {
			ctx.lineTo(item.x, item.y);
		});
		ctx.lineTo(this._opts.width, this._opts.height - 1);
		ctx.closePath();
		ctx.fill();
		ctx.stroke();

		ctx.strokeStyle = this._opts.colors.filling;
		ctx.fillStyle = this._opts.colors.filling;

		// spodni cast a meritko
		ctx.strokeStyle = this._opts.colors.measure;
		ctx.fillStyle = this._opts.colors.measure;
		ctx.beginPath();
		ctx.moveTo(0, this._opts.height - 1);
		ctx.lineTo(this._opts.width - 1, this._opts.height - 1);
		ctx.stroke();

		measure.forEach(item => {
			ctx.beginPath();
			ctx.moveTo(item.x, item.y);
			ctx.lineCap = "square";
			ctx.lineTo(item.x, this._opts.height - 1);
			ctx.stroke();
		});

		// horni cast
		ctx.beginPath();
		ctx.lineJoin = "round";
		ctx.lineCap = "square";
		ctx.strokeStyle = this._opts.colors.topLine;
		ctx.fillStyle = this._opts.colors.topLine;

		items.forEach(item => {
			ctx.lineTo(item.x, item.y);
		});

		ctx.stroke();

		// min a max
		ctx.strokeStyle = this._opts.colors.minMaxLine;
		ctx.fillStyle = this._opts.colors.circleFill;

		// max a min
		[this._minAltitude, this._maxAltitude].forEach(item => {
			if (!item) return;

			// posuneme od okraju o edgeThreshold [px] - samozrejme to pak nevychazi, ale aspon jde neco videt
			let edgeThreshold = this._opts.circleRadius;
			let x = Math.max(Math.min(item.x, this._opts.width - 1 - edgeThreshold), edgeThreshold);

			ctx.beginPath();
			ctx.arc(x, item.y, this._opts.circleRadius, 0, 2 * Math.PI, true);
			ctx.fill();
			ctx.stroke();

			ctx.beginPath();
			ctx.moveTo(x, item == this._maxAltitude ? this._topPaddingPy.max : this._topPaddingPy.min);
			ctx.lineTo(x, item.y - this._opts.circleRadius);
			ctx.stroke();
		});

		if (this._drawLine) {
			ctx.strokeStyle = this._opts.colors.minMaxLine;
			ctx.fillStyle = this._opts.colors.minMaxLine;

			ctx.beginPath();
			ctx.moveTo(this._drawLine.x, this._topPaddingPy.max);
			ctx.lineTo(this._drawLine.x, this._opts.height - 1);
			ctx.stroke();
		}
	}

	/**
	 * Obsluha mysi
	 *
	 * @param  {Event} e
	 */
	handleEvent(e) {
		if (!this._dom.canvas || this._distance === 0) return;

		if (e.type == "mousemove" || e.type == "click") {
			this._clearMoveInterval();

			let mouseData = this._getMouseData(e.clientX);

			if (e.type == "click") {
				this._dom.canvasCover.classList.add("show-popup");
			}

			if (!mouseData.item) return;

			this._mouseMoveData.id = setTimeout(() => {
				this._drawLine = Object.assign({}, mouseData.item, {
					x: mouseData.frac * (this._opts.width - 1),
					perc: mouseData.frac
				});

				this._animation();
				this._setTopPopup();
				this._setBottomPopup();
				this._sendSignal("line-chart-move", mouseData);

			}, this._mouseMoveData.timeout);
		}
		else if (e.type == "mouseenter") {
			this._clearMoveInterval();

			let mouseData = this._getMouseData(e.clientX);

			this._dom.canvasCover.classList.add("show-popup");
			this._sendSignal("line-chart-enter", mouseData);
		}
		else if (e.type == "mouseleave") {
			this._clearMoveInterval();

			this.clear();
			this._sendSignal("line-chart-leave");
		}
	}

	/**
	 * Nastaveni pozice popisku.
	 * Musi byt vyskovy profil pripnuty do DOMu.
	 */
	setCaptionsPositions() {
		this._waitForDOM();
	}

	/**
	 * Vytvoreni DOMu.
	 */
	_create() {
		// vytvoreni
		if ("ServerSide" in window) {
			return;
		}

		let title = document.createElement("h3");
		title.textContent = _("lineChart.title");

		let desc = document.createElement("p");
		desc.classList.add("desc");

		let elevationGainIcon = icon("ascending");
		elevationGainIcon.setAttribute("role", "img");
		elevationGainIcon.setAttribute("aria-label", _("lineChart.elevationGain"));
		let elevationGainValue = document.createElement("span");
		elevationGainValue.classList.add("value");

		let elevationLossIcon = icon("descending");
		elevationLossIcon.setAttribute("role", "img");
		elevationLossIcon.setAttribute("aria-label", _("lineChart.elevationLoss"));
		let elevationLossValue = document.createElement("span");
		elevationLossValue.classList.add("value");

		desc.appendChild(elevationGainIcon);
		desc.appendChild(elevationGainValue);
		desc.appendChild(elevationLossIcon);
		desc.appendChild(elevationLossValue);

		let canvasCover = document.createElement("div");
		canvasCover.classList.add("canvas-cover");
		canvasCover.addEventListener("mousemove", this);
		canvasCover.addEventListener("mouseenter", this);
		canvasCover.addEventListener("mouseleave", this);
		canvasCover.addEventListener("click", this);

		let canvas = document.createElement("canvas");

		// popup
		let popup = document.createElement("div");
		popup.classList.add("popup");

		let popupAltitude = document.createElement("span");
		popupAltitude.classList.add("altitude-part");

		let popupAltitudeValue = document.createElement("span");
		popupAltitudeValue.classList.add("value");

		let popupAltitudeUnit = document.createElement("span");
		popupAltitudeUnit.classList.add("unit");

		popupAltitude.appendChild(popupAltitudeValue);
		popupAltitude.appendChild(popupAltitudeUnit);

		popup.appendChild(popupAltitude);

		// spodni popup
		let bottomPopup = document.createElement("div");
		bottomPopup.classList.add("bottom-popup");

		let bottomPopupTimeValue = document.createElement("span");
		bottomPopupTimeValue.classList.add("value");

		let bottomPopupTimeUnit = document.createElement("span");
		bottomPopupTimeUnit.classList.add("unit");

		let bottomPopupDistanceValue = document.createElement("span");
		bottomPopupDistanceValue.classList.add("value");

		let bottomPopupDistanceUnit = document.createElement("span");
		bottomPopupDistanceUnit.classList.add("unit");

		bottomPopup.appendChild(bottomPopupTimeValue);
		bottomPopup.appendChild(bottomPopupTimeUnit);
		bottomPopup.appendChild(bottomPopupDistanceValue);
		bottomPopup.appendChild(bottomPopupDistanceUnit);

		canvasCover.appendChild(canvas);
		canvasCover.appendChild(popup);
		canvasCover.appendChild(bottomPopup);

		if (!this._opts.noTitle) {
			this._dom.cover.appendChild(title);
		}
		this._dom.cover.appendChild(desc);
		this._dom.cover.appendChild(canvasCover);

		this._dom.canvas = canvas;
		this._dom.canvasCover = canvasCover;
		this._dom.popup = popup;
		this._dom.popupAltitudeValue = popupAltitudeValue;
		this._dom.popupAltitudeUnit = popupAltitudeUnit;
		this._dom.bottomPopup = bottomPopup;
		this._dom.bottomPopupTimeValue = bottomPopupTimeValue;
		this._dom.bottomPopupTimeUnit = bottomPopupTimeUnit;
		this._dom.bottomPopupDistanceValue = bottomPopupDistanceValue;
		this._dom.bottomPopupDistanceUnit = bottomPopupDistanceUnit;
		this._dom.elevationGainValue = elevationGainValue;
		this._dom.elevationLossValue = elevationLossValue;
	}

	/**
	 * Nastaveni novych hodnot.
	 */
	_set() {
		// reset
		while (this._dom.captions.length) {
			this._dom.captions.pop().remove();
		}

		if (this._distance <= 0) {
			this._dom.cover.classList.add("hide");
			return;
		}

		this._dom.cover.classList.remove("hide");

		// nastaveni
		this._dom.elevationGainValue.textContent = this._formatElevation(this._processedData.elevationGain);
		this._dom.elevationLossValue.textContent = this._formatElevation(this._processedData.elevationLoss);
		this._dom.canvasCover.style.width = this._opts.width + "px";
		this._dom.canvasCover.style.height = this._opts.height + "px";
		this._dom.canvas.style.width = this._opts.width + "px";
		this._dom.canvas.style.height = this._opts.height + "px";
		this._dom.canvas.width = this._opts.width;
		this._dom.canvas.height = this._opts.height;

		// popisky
		if (this._minAltitude) {
			let minAltitudeCaption = this._createCaption(this._minAltitude.value, this._minAltitude.unit);
			minAltitudeCaption.classList.add("min-max");
			minAltitudeCaption.style.left = this._minAltitude.x + "px";
			minAltitudeCaption.style.top = this._topPaddingPy.min + "px";

			this._dom.captions.push(minAltitudeCaption);
			this._dom.minAltitudeCaption = minAltitudeCaption;
		}

		if (this._maxAltitude) {
			let maxAltitudeCaption = this._createCaption(this._maxAltitude.value, this._maxAltitude.unit);
			maxAltitudeCaption.classList.add("min-max");
			maxAltitudeCaption.style.left = this._maxAltitude.x + "px";
			maxAltitudeCaption.style.top = this._topPaddingPy.max + "px";

			this._dom.captions.push(maxAltitudeCaption);
			this._dom.maxAltitudeCaption = maxAltitudeCaption;
		}

		// meritko
		this._sectionItems.forEach(section => {
			let el = this._createCaption(section.value, section.unit);
			el.classList.add("measure");
			el.style.left = section.x + "px";
			el.style.top = (this._opts.height - 1) + "px";

			this._dom.captions.push(el);
		});

		this._dom.captions.forEach(el => {
			this._dom.canvasCover.appendChild(el);
		});
	}

	/**
	 * Zpracovani vstupnich dat - stoupani, klesani, min a max vyska, samplovani dat.
	 */
	_processData() {
		if (this._altitudeData) {
			if (Array.isArray(this._altitudeData.data)) {
				// alt, dist, lon, lat, niceAlt, space: false
				let allDistances = [];
				this._altitudeData.data.forEach((i, ind) => {
					allDistances.push((ind > 0 ? allDistances[ind - 1] : 0) + i.dist);
				});
				let ratio = this._distance / allDistances[allDistances.length - 1];

				this._items = this._altitudeData.data.map((i, ind) => {
					return Object.assign({}, i, {
						space: false,
						dist: allDistances[ind] * ratio
					});
				});
				this._processedData.minAltitude = this._altitudeData.min;
				this._processedData.maxAltitude = this._altitudeData.max;
				this._processedData.elevationGain = Math.round(this._altitudeData.gain);
				this._processedData.elevationLoss = Math.round(this._altitudeData.loss);
			}
		} else if (this._opts.activityData) {
			let sznAltitude = this._opts.activityData.info.sznAltitude;

			this._processedData.minAltitude = sznAltitude.min;
			this._processedData.maxAltitude = sznAltitude.max;
			this._processedData.elevationGain = Math.round(sznAltitude.gain);
			this._processedData.elevationLoss = Math.round(sznAltitude.loss);
			this._items.length = 0;

			let allDistances = 0;

			sznAltitude.data.forEach(i => {
				this._items.push({
					alt: i.alt,
					niceAlt: i.niceAlt,
					lon: i.lon,
					lat: i.lat,
					dist: allDistances + i.dist,
					space: false
				});

				allDistances += i.dist;
			});

			let ratio = this._distance / allDistances;

			this._items.forEach(i => i.dist *= ratio);
		}

		// mame data lon, lat, pripravime data pro graf
		let heightDistance = Math.max(this._processedData.maxAltitude - this._processedData.minAltitude, 1);
		let topPaddingPy = Math.round(this._opts.topPadding + this._opts.maxPeakPadding);
		let availPxY = Math.round(this._opts.height - topPaddingPy - this._opts.bottomHeight);
		let heightPxRatio =  availPxY / heightDistance;
		let addPaddingTop = 0;

		if (heightPxRatio > 1) {
			// omezime na pulku vysky
			addPaddingTop = Math.round((availPxY - heightDistance) / 2);
			availPxY = heightDistance;
		}

		let minAltValue = Infinity;
		let minAltItem = null;
		let maxAltValue = -Infinity;
		let maxAltItem = null;

		this._drawItems.length = 0;

		this._items.forEach((i, ind) => {
			let perc = Math.min(i.dist / this._distance, 100);
			let x = perc * (this._opts.width - 1);
			let y = Math.round(topPaddingPy + addPaddingTop + availPxY * (1 - (i.niceAlt - this._processedData.minAltitude) / heightDistance));
			let drawItem = {
				perc,
				x,
				y,
				item: i
			};

			if (i.alt < minAltValue) {
				minAltValue = i.alt;
				minAltItem = drawItem;
			}

			if (i.alt > maxAltValue) {
				maxAltValue = i.alt;
				maxAltItem = drawItem;
			}

			// jednotlive body k vykresleni
			this._drawItems.push(drawItem);

			// skoky
			if (i.space) {
				let breakPerc = this._items[ind + 1].dist / this._distance;
				let breakX = breakPerc * (this._opts.width - 1);

				// zlomovy bod
				this._drawItems.push({
					perc: breakPerc,
					x: breakX,
					y,
					item: i
				});
			}
		});

		this._minAltitude = Object.assign({}, minAltItem, this._valueWithUnit(this._processedData.minAltitude, this._opts.yUnits));
		this._maxAltitude = Object.assign({}, maxAltItem, this._valueWithUnit(this._processedData.maxAltitude, this._opts.yUnits));

		// osetreni pro posledni bod - pokud neni na 100%
		if (this._drawItems.length && this._drawItems[this._drawItems.length - 1].perc < 1) {
			let lastItem = this._drawItems[this._drawItems.length - 1];

			this._drawItems.push({
				perc: 1,
				x: this._opts.width - 1,
				y: lastItem.y,
				item: lastItem.item
			});
		}
	}

	/**
	 * Vytvoreni polozek pro meritko - spocitani spravneho meritka pro dilek.
	 *
	 * @return {Array}
	 */
	_getSectionItems() {
		let sectionItems = [];
		let distance = this._distance;
		let multiplier = 1;

		if (distance <= 0 || !this._drawItems.length) {
			return sectionItems;
		}

		// km - pouze u vzdalenosti vetsi jak 1000m a jeden dilek je vetsi jak pocet dilku meritka
		if (Math.round(distance / ((this._opts.measureSections + 1) * 1000)) > this._opts.measureSections) {
			distance = Math.round(distance / 1000);
			multiplier = 1000;
		}

		let part = Math.round(distance / (this._opts.measureSections + 1));
		let dd = this._getDecDivider(part);
		let partRest = dd > 0 ? part % dd : part;
		let decValue = part - partRest;
		let testPart = null;

		// test, jestli muzou byt v meritku hezke hodnoty 0, 5
		if (partRest > 0 && partRest < 5) {
			testPart = 5 + decValue;
		}
		else if (partRest > 5 && partRest < 10) {
			testPart = decValue + 10;
		}

		// nova hodnota - nesmi to byt uplne nalepene vpravo
		if (testPart !== null && testPart * this._opts.measureSections <= distance * 0.9) {
			part = testPart;
		}

		let maxPtr = this._opts.width - 1;

		for (let i = 1; i <= this._opts.measureSections; i++) {
			let value = part * i;
			let x = Math.round(maxPtr * value / distance);
			let perc = x / this._opts.width;

			let prevItem = null;
			let item = null;

			for (let i = 0; i < this._drawItems.length; i++) {
				let it = this._drawItems[i];

				if (it.perc < perc) {
					prevItem = it;
				}
				else {
					item = it;
					break;
				}
			}

			if (!item || !prevItem) { break; }

			let yDiff = prevItem.y - item.y;
			let xDiff = prevItem.x - item.x;

			sectionItems.push(Object.assign({
				x: x,
				y: prevItem.y + ((x-prevItem.x) / xDiff * yDiff)
			}, this._valueWithUnit(value * multiplier, this._opts.xUnits)));
		}

		return sectionItems;
	}

	/**
	 * U cisla vraci jeho desitkovy delitel.
	 * 15 -> 1; 6 -> 0; 99 -> 1; 154 -> 2...
	 *
	 * @param  {Number} value Vstupni hodnota
	 * @return {Number} Vystupni delitel
	 */
	_getDecDivider(value) {
		if (value < 10) {
			return 0;
		}
		else {
			return Math.floor(Math.log(value) / Math.log(10)) * 10;
		}
	}

	/**
	 * Format klesani a stoupani - u cs oddelujeme tisice.
	 *
	 * @param  {Number} value Vstupni hodnota
	 * @return {String}
	 */
	_formatElevation(value) {
		return (Mapy.Util.formatLocaleNumber(value) + " m");
	}

	/**
	 * Format metry nebo km
	 *
	 * @param  {Float} value Hodnota
	 * @return {Object} zpracovana hodnota a jeji jednotka
	 */
	_formatDistance(value) {
		let unit = "m";

		if (value > 100) {
			value = (value / 1000).toFixed(1);
			value = value.indexOf(".0") != -1 ? value.replace(".0", "") : value;
			unit = "km";
		}
		else {
			value = Math.floor(value).toString();
		}

		return {
			value,
			unit
		};
	}

	/**
	 * Format: 0:00 HODIN:MM
	 *
	 * @param  {Float} value Hodnota
	 * @return {Object} zpracovana hodnota a jeji jednotka
	 */
	_formatTime(value) {
		let hours = Math.floor(value / 3600);
		value -= hours * 3600;
		let minutes = Math.floor(value / 60);
		minutes = minutes < 10 ? "0" + minutes : minutes;

		return {
			value: hours + ":" + minutes,
			unit: "hod"
		};
	}

	/**
	 * Vytvoreni popisku nad canvasem.
	 *
	 * @param  {String} value Napln hodnoty
	 * @param  {String} unit Napln jednotky
	 * @return {Element}
	 */
	_createCaption(value, unit) {
		let el = document.createElement("div");
		el.classList.add("canvas-caption");

		let valueEl = document.createElement("span");
		valueEl.classList.add("value");
		valueEl.textContent = Mapy.Util.formatLocaleNumber(value);

		let unitEl = document.createElement("span");
		unitEl.classList.add("unit");
		unitEl.textContent = unit;

		el.appendChild(valueEl);
		el.appendChild(unitEl);

		return el;
	}

	/**
	 * Vyslani signalu posluchaci.
	 *
	 * @param  {String} name Nazev signalu
	 * @param  {Object} [data] Volitelna data
	 */
	_sendSignal(name, data) {
		this._signals.forEach(signal => {
			if (signal.name == name) {
				signal.cb.apply(signal.scope || this, [data]);
			}
		});
	}

	/**
	 * Nastaveni horniho popupu - horni popup s vyskou a moznosti rychlosti.
	 */
	_setTopPopup() {
		let dl = this._drawLine;

		if (!dl) return;

		this._dom.popup.style.left = dl.x + "px";

		let altitude = this._valueWithUnit(dl.alt, this._opts.yUnits);

		this._dom.popupAltitudeValue.textContent = Mapy.Util.formatLocaleNumber(altitude.value);
		this._dom.popupAltitudeUnit.textContent = altitude.unit;

		// smazame tridy
		this._dom.popup.classList.remove("left");
		this._dom.popup.classList.remove("right");

		if (dl.perc <= this._opts.leftRightEdge/100) {
			this._dom.popup.classList.add("left");
		}
		else if (dl.perc >= (1 - this._opts.leftRightEdge/100)) {
			this._dom.popup.classList.add("right");
		}
	}

	/**
	 * Spodni popup - pouze u rychlosti, zobrazuje cas a delku od startu.
	 */
	_setBottomPopup() {
		let dl = this._drawLine;

		if (!dl) return;

		let distance = this._valueWithUnit(dl.dist, this._opts.yUnits);

		this._dom.bottomPopup.style.left = this._drawLine.x + "px";
		this._dom.bottomPopupDistanceValue.textContent = Mapy.Util.formatLocaleNumber(distance.value);
		this._dom.bottomPopupDistanceUnit.textContent = distance.unit;
		this._dom.bottomPopup.classList[dl.perc <= 0.50 ? "add" : "remove"]("left");
	}

	/**
	 * Animace pri vytvoreni.
	 */
	_animation() {
		if (this._t >= 1) {
			this.redraw();
			return;
		}

		this._increase = this._increase * this._opts.animationIncreaseExponent;
		this._t += this._increase;

		let data = this._drawItems.map((item, i) => {
			let base = this._prevBaseY && this._prevBaseY[i] ? this._prevBaseY[i] : this._minAltitude.y;
			let newItem = {
				x: item.x,
				y: (item.y - base) * this._t + base
			};

			if (i == this._minAltitude.x) {
				this._minAltitude.y = item.y >= newItem.y ? item.y : newItem.y;
			}

			if (i == this._maxAltitude.x) {
				this._maxAltitude.y = item.y >= newItem.y ? item.y : newItem.y;
			}

			if (item.y == newItem.y) return item;
			return newItem;
		});

		let measure = this._sectionItems.map((item) => {
			let newItem = Object.assign({}, item);
			newItem.y = (item.y - this._minAltitude.y) * this._t + this._minAltitude.y;

			if (item.y >= newItem.y) return item;
			return newItem;
		});

		this.redraw(data, measure);

		requestAnimationFrame(() => {
			this._animation();
		});
	}

	/**
	 * Vycisteni timeoutu u pohybu mysi.
	 */
	_clearMoveInterval() {
		if (this._mouseMoveData.id) {
			clearTimeout(this._mouseMoveData.id);
			this._mouseMoveData.id = null;
		}
	}

	/**
	 * Formatovani vzdalenosti.
	 *
	 * @param {Integer} inputValue - hodnota
	 * @param {object} units - objekt s jednotkami
	 * @param {object} [obj] Ulozit hodnoty rovnou do objektu?
	 */
	_valueWithUnit(inputValue, units, obj) {
		let value = Math.round(inputValue);
		let unit = "";

		for (let p in units) {
			if (Math.floor(inputValue / parseInt(p)) >= 1) {
				let format = inputValue / parseInt(p);
				let prepare = Math.round(format * 10 ) / 10;
				let dec = (format < 10 && prepare % 1 ? 1 : 0);
				value = format.toFixed(dec);
				unit = units[p];
			}
			else if (inputValue < 1) {
				unit = units[p];
				break;
			}
			else {
				break;
			}
		}

		if (obj) {
			obj.value = value;
			obj.unit = unit;
		}

		return {
			value,
			unit
		};
	}

	/**
	 * Ziskani dat pri interakci s mysi.
	 *
	 * @param  {Number} mouseX Poloha mysi.
	 * @return {Object}
	 */
	_getMouseData(mouseX) {
		let cbr = this._dom.canvas.getBoundingClientRect();
		let x = mouseX - Math.floor(cbr.left);
		let frac = x / (this._opts.width - 1);
		let item = this._getItemOnPerc(frac);

		return {
			frac,
			x,
			item
		};
	}

	_getItemOnPerc(frac) {
		let px = Math.floor(frac * (this._opts.width - 1));

		if (px == Math.floor(this._minAltitude.x)) {
			return this._minAltitude.item;
		}
		else if (px == Math.floor(this._maxAltitude.x)) {
			return this._maxAltitude.item;
		}
		else if (frac === 0) {
			return this._drawItems[0].item;
		}
		else if (frac === 1) {
			return this._drawItems[this._drawItems.length - 1].item;
		} else {
			const curDist = this._distance * frac;
			let outputItem = null;

			for (let i = 0, max = this._drawItems.length; i < max; i++) {
				const item = this._drawItems[i].item;
				const nextItem = this._drawItems[i + 1]?.item;

				if (curDist >= item.dist && nextItem && curDist <= nextItem.dist) {
					const dist = nextItem.dist - item.dist;
					const ratioLeft = 1 - ((curDist - item.dist) / dist);
					const ratioRight = 1 - ((nextItem.dist - curDist) / dist);

					outputItem = {
						...item,
						alt: Math.round(item.alt * ratioLeft + nextItem.alt * ratioRight),
					};
					break;
				}
			}

			return outputItem;
		}
	}

	/**
	 * Cekani na nacteni domu.
	 */
	_waitForDOM() {
		if (!this._domLoaded) {
			if (this._dom.canvasCover && this._dom.canvasCover.offsetWidth) {
				this._domLoaded = true;
				this._setCaptionsPositions();
			}
			else if (this._domCount === 0) {
				// reset
				this._domCount = this._opts.domLoadCount;
			}
			else {
				this._domCount--;

				this._domTimeout = setTimeout(() => {
					this._waitForDOM();
					this._domTimeout = null;
				}, this._opts.domLoadTimeout);
			}
		}
		else {
			this._setCaptionsPositions();
		}
	}

	/**
	 * Pozice popisku, musi byt DOM data (sirky), potom je zarovname tak, aby se neprekryvaly.
	 */
	_setCaptionsPositions() {
		if (!this._items.length || !this._domLoaded) return;

		// zarovname max - samo na svem lvl
		this._reposition(this._dom.maxAltitudeCaption);
		// zarovname min - samo na svem lvl
		this._reposition(this._dom.minAltitudeCaption);
	}

	/**
	 * Urceni pozice itemu tak, aby se neprekryvaly.
	 * Ziskame data elementu - sirky, left, pak je seradime zleva doprava, urcime nove hodnoty left a provedeme zmeny v DOMu.
	 *
	 * @param  {Array|Element} els 1..n elementu
	 */
	_reposition(els) {
		els = Array.isArray(els) ? els : [els];

		// pridame padding mezi polozkami
		let wholeWidth = Math.max(els.length - 1, 0) * this._opts.domRepositionPadding;
		let items = els.map(el => {
			let leftX = parseFloat(el.style.left.replace("px", ""));
			let width = el.offsetWidth;
			let halfWidth = width / 2;
			let leftEdgeX = leftX - halfWidth;
			let rightEdgeX = leftX + halfWidth;

			wholeWidth += width;

			return {
				el,
				leftX,
				origLeftX: leftX,
				width,
				halfWidth,
				leftEdgeX,
				rightEdgeX
			};
		});
		let len = items.length;

		if (wholeWidth <= this._opts.width && len > 0) {
			// seradime center zleva doprava
			if (len > 1) {
				items.sort((a, b) => {
					return (a.leftX - b.leftX);
				});
			}

			items.forEach((i, ind) => {
				// zarovnani u prvniho a posledniho
				if (ind === 0 && i.leftEdgeX < 0) {
					i.leftEdgeX = this._opts.domEdgeCorrection;
					i.leftX = i.leftEdgeX + i.halfWidth;
					i.rightEdgeX = i.leftX + i.halfWidth;
				}
				if (ind === len - 1 && i.rightEdgeX > this._opts.width) {
					i.rightEdgeX = this._opts.width - this._opts.domEdgeCorrection;
					i.leftX = i.rightEdgeX - i.halfWidth;
					i.leftEdgeX = i.leftX - i.halfWidth;
				}

				// testy pro predchozi itemy
				if (ind > 0) {
					let prev = items[ind - 1];

					if (prev.rightEdgeX > i.leftEdgeX || Math.abs(prev.rightEdgeX - i.leftEdgeX) <= this._opts.domRepositionPadding) {
						// zbyva rozdelit mezi dvema itemy
						let rest = Math.abs(prev.rightEdgeX - i.leftEdgeX);
						let prevPrev = ind > 1 ? items[ind - 2] : null;

						// zkusime posunout predesly
						if ((ind == 1 && prev.leftEdgeX - rest >= this._opts.domEdgeCorrection) || (ind > 1 && prev.leftEdgeX - rest >= prevPrev.rightEdgeX)) {
							// jde to
							let halfRest = rest / 2 + this._opts.domRepositionPadding;
							i.leftX += halfRest;
							prev.leftX -= halfRest;
							prev.leftEdgeX = prev.leftX - prev.halfWidth;
							prev.rightEdgeX = prev.leftX + prev.halfWidth;
						}
						else {
							// nejde to, posuneme pouze aktualni
							i.leftX = prev.rightEdgeX + this._opts.domRepositionPadding + i.halfWidth;
						}

						i.leftEdgeX = i.leftX - i.halfWidth;
						i.rightEdgeX = i.leftX + i.halfWidth;
					}
				}
			});

			// po napozicovani provedeme zmeny v DOMu
			items.forEach(i => {
				if (i.leftX == i.origLeftX) return;

				i.el.style.left = i.leftX + "px";
			});
		}
		else {
			// eslint-disable-next-line no-console
			console.error("Error - not enough space!");
		}
	}
}
